import HebrewDefinition from "./HebrewDefinition";

export default class HebrewDefinitionLookup {

    private definitions: Map<string, string[]> = new Map();

    public constructor(definitions: HebrewDefinition[]) {
        definitions.forEach(definition => {
            this.addDefinitions(definition.getWord(), definition.getDefinitions());
            this.addDefinitions(definition.getSimpleWord(), definition.getDefinitions());
        });
    }

    public getDefinitions(word: string): string[] {
        return this.definitions.get(word) || [];
    }

    public getMainDefinition(word: string): string {
        const definitions = this.definitions.get(word);
        if (definitions === undefined || definitions.length === 0) {
            return '';
        }
        return definitions[0];
    }

    private addDefinitions(word: string, definitions: string[]): void {
        const existingDefinitions = this.definitions.get(word) || [];
        const newDefinitions = existingDefinitions.concat(definitions);
        const deduplicated = Array.from(new Set(newDefinitions));
        this.definitions.set(word, deduplicated);
    }
}
